import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuiDimmerComponent } from './dimmer.component';

@NgModule({
    imports: [CommonModule],
    exports: [EuiDimmerComponent],
    declarations: [EuiDimmerComponent]
})
export class EuiDimmerModule {
}
